import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import {
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab,
  togglePromotionModalView
} from '../../actions';
import CONFIG from '../../config';
import useScreenSize from '../../hooks/useScreenSize';
import {
  LogoFlexibleBlock,
  StyledLogoIcon,
  Switcher,
  SwitcherBlock,
  SwitcherIcon
} from './styled';
import HeaderModalMenu from '../HeaderModalMenu';

const HamburgerMenu = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [isOpenHeaderMenu, setIsOpenHeaderMenu] = useState(false);
  const [isHoveringModal, setIsHoveringModal] = useState(false);
  const [isHoveringSwitcher, setIsHoveringSwitcher] = useState(false);
  const { isSmall } = useScreenSize();
  const { contacts } = CONFIG;

  const handleLogoClick = () => {
    dispatch(switchTab(0));
    dispatch(setChosenLocationNames([]));
    dispatch(setLocationIds([]));
    dispatch(setCurrentState(null));
    dispatch(togglePromotionModalView(false));

    return router.push('/');
  };

  const onSwitcherClick = () => {
    setIsOpenHeaderMenu(isOpen => !isOpen);
  };

  const handleSwitcherMouseEnter = () => {
    setIsHoveringSwitcher(true);
  };

  const handleSwitcherMouseLeave = () => {
    setIsHoveringSwitcher(false);
  };

  const handleModalMenuMouseEnter = () => {
    setIsHoveringModal(true);
  };

  const handleModalMenuMouseLeave = () => {
    setIsHoveringModal(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isHoveringModal && !isHoveringSwitcher) {
        setIsOpenHeaderMenu(false);
      } else {
        setIsOpenHeaderMenu(true);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [isHoveringModal, isHoveringSwitcher]);

  return (
    <LogoFlexibleBlock data-cy="header-menu">
      {!isSmall && (
        <SwitcherBlock
          onClick={onSwitcherClick}
          onKeyPress={onSwitcherClick}
          onMouseEnter={handleSwitcherMouseEnter}
          onMouseLeave={handleSwitcherMouseLeave}
          role="button"
          tabIndex="0"
        >
          <Switcher
            active={isOpenHeaderMenu}
            data-cy="header-menu-toggle-icons"
          >
            <SwitcherIcon active={isOpenHeaderMenu} />
          </Switcher>
        </SwitcherBlock>
      )}
      <StyledLogoIcon
        data-cy="header-menu-logo"
        stat="header-menu-logo"
        onClick={handleLogoClick}
        onKeyPress={handleLogoClick}
        role="button"
        tabIndex="-1"
        src="/static/images/brown-logo.svg"
        alt="logo"
        width={isSmall ? 85 : 80}
        height={19}
        isShowBurgerIcon={!isSmall}
      />
      <HeaderModalMenu
        {...{
          contacts,
          isOpenHeaderMenu,
          setIsOpenHeaderMenu,
          handleModalMenuMouseLeave,
          handleModalMenuMouseEnter
        }}
      />
    </LogoFlexibleBlock>
  );
};

export default HamburgerMenu;
